import { makeVar } from '@apollo/client';
import { TableFilters, TableFilterValue } from 'src/@types/client';

export const createTableFiltersVar = <T extends TableFilters<Record<string, TableFilterValue>>>(defaultFilters: T) => {
  return makeVar<T>(defaultFilters);
};
